import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface CompareFaqProps {
  faqs: { q: string; a: string }[];
}

export function CompareFaq({ faqs }: CompareFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 border-t border-zinc-100">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <h2 className="font-display text-2xl md:text-3xl text-zinc-900 mb-2">
            Common questions
          </h2>
          <p className="text-sm text-zinc-500">
            Straight answers about switching to Kora.
          </p>
        </div>
        <div className="space-y-0">
          {faqs.map((item, i) => (
            <div key={i} className="border-b border-zinc-100">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="flex w-full items-center justify-between py-4 text-left"
              >
                <span className="text-sm font-medium text-zinc-900">{item.q}</span>
                <ChevronDown
                  className={`size-4 text-zinc-400 transition-transform shrink-0 ml-2 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === i && (
                <p className="pb-4 text-sm text-zinc-500 leading-relaxed">
                  {item.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
